<template>
  <zen-one 
  :showuserinfo="false" 
  title=""
  :crumbs="crumbs"
  >
  <z-page
  title="Cawangan"
  >

  <w-dialog
    ref="draggableDialog"
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="600"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
           <div
             class="dialog-title-dragger"
             @mousedown="initDrag"
             style="cursor: move; display: flex; align-items: center;"
           >
             <w-icon class="mr2">fal fa-cog</w-icon>
             {{ dialog.title }}
           </div>
         </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
    >
    <!-- <w-select :items="lkp_ternakan_id" label="Ternak"  v-model="form.lkp_ternakan_id" @input="getTernakNama()"></w-select> -->
    <z-input class="mt4" label="Kod" v-model="form.kode" name="Kod" :validators="[validators.required]" />
    <z-input class="mt4" label="Nama" v-model="form.nama" name="Nama" :validators="[validators.required]" />
    <z-input class="mt4" label="No Tel" v-model="form.no_tel" name="No Tel" :validators="[validators.required]" />
    
    <br>
    <z-input class="mt4" label="Alamat" v-model="form.alamat" name="Alamat" :validators="[validators.required]" />
    <z-select  class="mt4" :items="negeri" label="Negeri" @input="getDaerah(1)" v-model="form.lkp_negeri_id" :validators="[validators.required]" ></z-select>
    <z-select  class="mt4" :items="daerah" label="Daerah" @input="getBandar(1)" v-model="form.lkp_daerah_id" :validators="[validators.required]" ></z-select>
    <z-select 
     class="mt4"
     :items="bandar"
     label="Mukim/Bandar/Pekan"
     v-model="form.lkp_bandar_id"
     item-text="nama"
     item-value="id"
     @input="getPoskod()"
     :validators="[validators.required]"
   ></z-select>
    <z-select 
     class="mt4"
     :items="poskod"
     label="Poskod"
     v-model="form.lkp_poskod_id"
     item-text="poskod"
     item-value="id"
     :validators="[validators.required]"
   ></z-select>
    <w-switch class="mt4" width="col-12" v-model="form.status" label="Status" />
    </w-form>
        

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      @click="validateAndSubmit"
      >
        SIMPAN
      </w-button>
    </template>

    
  </w-dialog>
  

  <z-table
    ref="tbluser"
    title="Cawangan"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >


 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
       
        
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'penyelenggaraan.cawangan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Penyelenggaraan', route: '/penyelenggaraan' },
        { label: 'Cawangan', route: '/penyelenggaraan/lkp_cawangan' }
      ],
      
      form: {
        id: 0,
        nama: '',
        kode: '',
        status: '',
        no_tel: '',
        lkp_negeri_id:'',
        lkp_daerah_id:'',
        alamat: '',  
        lkp_bandar_id: '',
        lkp_poskod_id: '',
        

      },
      negeri:[],
      bandar: [],
      poskod: [],
      daerah: [],
      

    }
  },
  methods: {
    add(){
          this.form = {
              id : null,
              kode : null,
              nama : null,
              status : 1,
              lkp_negeri_id:'',
              lkp_daerah_id:'',
             
             

          }
          this.dialog.show = true
          this.dialog.title = 'TAMBAH'
          this.form.saveButton = "Save"
      },
      edit(form){
          this.form = form
          this.getNegeriCawangan()
          this.getPoskod()
          this.getBandar()
          this.getDaerah()
          this.dialog.show = true
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      },

      async validateAndSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        return
      }
      this.submit()
    },

       
      getBandar(id){
         if (id==1) {
            this.form.lkp_bandar_id == '';
         }
            this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_daerah_id, {}).then(res => {
               this.bandar = res
               this.form.p = id
            })
        },

        getDaerah(id){
         if (id==1) {
            this.form.lkp_daerah_id == '';
         }
            this.$zcomm.get(this.api_service + 'lookup/daerah/'+this.form.lkp_negeri_id, {}).then(res => {
               this.daerah = res
               this.form.p = id
            })
        },

        initDrag(e) {
     const dialog = this.$refs.draggableDialog?.$el
     const content = dialog?.querySelector('.w-dialog__content')
     if (!content) return

     content.style.position = 'fixed'
     content.style.margin = 0
     content.style.width = dialog.style.width || '500px'
     content.style.zIndex = 1050

     const startX = e.clientX
     const startY = e.clientY
     const rect = content.getBoundingClientRect()
     const origLeft = rect.left
     const origTop = rect.top

     const onMouseMove = (event) => {
       const dx = event.clientX - startX
       const dy = event.clientY - startY
       content.style.left = `${origLeft + dx}px`
       content.style.top = `${origTop + dy}px`
     }

     const onMouseUp = () => {
       document.removeEventListener('mousemove', onMouseMove)
       document.removeEventListener('mouseup', onMouseUp)
     }

     document.addEventListener('mousemove', onMouseMove)
     document.addEventListener('mouseup', onMouseUp)
   },

        getPoskod(id){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
              this.poskod = res
              this.form.p = id
            })
        },
      getNegeriCawangan(){
         this.$zcomm.get(this.api_service + 'lookup/negeri_cawangan', {}).then(res => {
          this.negeri = res
        })
      },
  },

  watch: {

  },
  mounted() {
    this.getNegeriCawangan()
    // this.getBandar()
    // this.getBandarPoskod()
    // this.getPoskodList()
    // override default setting
    this.dialog.width = 500
  
      
  },
}
</script>
<style scoped>
.w-dialog {
  position: fixed !important;
}
.draggable-dialog {
  position: fixed !important;
  margin: 0 !important;
  width: 500px !important;
  z-index: 1050;
}

</style>
